<template>
  <div>
    <div class="title-box">车间平面图信息</div>
    <!-- 查询条件 -->
    <el-form
      id="formID"
      :inline="true"
      :model="queryParams"
      style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
      class="demo-form-inline"
    >
      <el-form-item>
        <el-select v-model="queryParams.factoryId" filterable placeholder="选择工厂" @change="getWorkshopByFactory">
          <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="queryParams.workshopId" filterable placeholder="选择车间">
          <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="info" @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-tabs
      class="scene_tabs"
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      :style="'height:' + tableHeight + 'px'"
    >
      <el-tab-pane label="车间设计图" name="first">
        <iframe :src="scenePdf" width="100%" height="100%" frameborder="0"></iframe>
        <!-- <div id="workshopPdf"></div> -->
      </el-tab-pane>
      <el-tab-pane label="场景分布示意图" name="second">
        <div id="container" ref="graphRef"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { Graph } from '@antv/x6';
// import pdf from 'vue-pdf';
// import { getDocument } from 'pdfjs-dist/webpack';

export default {
  data() {
    return {
      // 查询条件
      queryParams: {
        factoryId: null,
        workshopId: null
      },
      //工厂类型
      factoryOptions: [],
      workshopOptions: [],
      activeName: 'first',
      tableHeight: 650,
      scenePdf: '',
      sceneJson: {},
      graph: null,
      isMounted: false
    };
  },
  methods: {
    initGraph() {
      this.graph = new Graph({
        container: this.$refs.graphRef,
        width: 800,
        height: 600,
        panning: {
          // 禁用画布拖拽
          enabled: true // 关闭画布平移
        },
        interacting: {
          // 控制交互行为
          nodeMovable: (cellView) => {
            // 父节点不可移动，子节点可移动
            return !cellView.cell.data || !cellView.cell.data.isParent;
          }
        },
        translating: {
          // 子节点只能在父节点内移动
          restrict(view) {
            const cell = view.cell;
            if (cell.isNode()) {
              const parent = cell.getParent();
              if (parent) {
                return parent.getBBox();
              }
            }

            return null;
          }
        },
        mousewheel: {
          enabled: true, // 启用滚轮缩放
          zoomAtMousePosition: true, // 以鼠标位置为中心缩放
          modifiers: [], // 无需按修饰键（默认需要按ctrl）
          minScale: 0.5, // 最小缩放比例
          maxScale: 3, // 最大缩放比例
          zoomFactor: 0.1 // 缩放速度
        },
        background: {
          color: '#F2F7FA'
        },
        grid: {
          visible: true,
          type: 'doubleMesh',
          args: [
            {
              color: '#eee', // 主网格线颜色
              thickness: 1 // 主网格线宽度
            },
            {
              color: '#ddd', // 次网格线颜色
              thickness: 1, // 次网格线宽度
              factor: 4 // 主次网格线间隔
            }
          ]
        }
      });
    },
    // 查询车间设计图/场景示意图
    getWorkshopInfo() {
      if (this.queryParams.workshopId) {
        if (this.activeName == 'first') {
          //车间设计图
          this.$store.dispatch('workshop/getWorkshop', { id: this.queryParams.workshopId }).then((result) => {
            if (result && result.data && result.data.fileId) {
              this.$store.dispatch('oss/getOssDetail', { ossId: result.data.fileId }).then((res) => {
                if (res?.data) {
                  this.scenePdf = res.data.url;
                  // 释放内存
                  setTimeout(() => {
                    window.URL.revokeObjectURL(this.scenePdf);
                  }, 100);
                }
              });
            }
          });
        } else if (this.activeName == 'second') {
          //场景示意分布图
          this.$store
            .dispatch('scene/getSceneDistribution', { workshopId: this.queryParams.workshopId })
            .then((res) => {
              if (res.code === 200) {
                const { workshopSceneLayoutData, workshopSceneLayoutJsonStr } = res.data;
                if (workshopSceneLayoutData && workshopSceneLayoutJsonStr) {
                  this.sceneJson = JSON.parse(workshopSceneLayoutJsonStr);
                  const cells = this.sceneJson.cells;

                  if (workshopSceneLayoutData && workshopSceneLayoutJsonStr) {
                    // 处理点位数据
                    workshopSceneLayoutData.forEach((scene) => {
                      scene.scenePointInfoList.forEach((point) => {
                        const pointCell = cells.find((cell) => cell.id === point.cellId);
                        if (pointCell) {
                          pointCell.data = {
                            ...pointCell.data,
                            pointId: point.pointId,
                            deviceId: point.deviceId,
                            cellId: point.cellId
                          };
                        }
                      });
                    });
                  }
                  this.graph.fromJSON(this.sceneJson); // 渲染元素
                  const nodes = this.graph.getNodes();
                  // 更新节点样式
                  this.updataNodesStyle(nodes);
                  this.graph.centerContent(); // 居中显示
                }
              }
            });
        }
      }
    },
    // 更新节点样式
    updataNodesStyle(nodes) {
      let noDeviceColor = '#8f8f8f'; // 没有设备的颜色
      let deviceColor = '#7719aa'; // 绑定设备的颜色

      nodes.forEach((node) => {
        // 3. 检查是否为节点（现在使用正确的图形对象）
        if (node.isNode()) {
          // 节点如果是子节点，有id且没有设备id则只是保存 没有绑定设备。颜色是noDeviceColor: '#8f8f8f',
          // 节点如果是子节点，有id且有设备id则已经绑定设备deviceColor: '#1ecb80'
          if (node.isNode() && node.getParent()) {
            const data = node.getData();
            if (data.pointId && !data.deviceId) {
              node.attr('body/fill', noDeviceColor);
              node.attr('body/stroke', noDeviceColor);
            }

            if (data.pointId && data.deviceId) {
              node.attr('body/fill', deviceColor);
              node.attr('body/stroke', deviceColor);
            }
          }
        }
      });
    },
    handleClick(data) {
      this.activeName = data.name;
      this.getWorkshopInfo();
    },
    // 监听窗口缩放
    handleResize() {
      // 当窗口大小变化时，这个函数会被调用
      const height = window.innerHeight;
      let dom = document.getElementById('formID');
      let formH = 70; //一行时高度为70
      if (dom) {
        formH = dom.offsetHeight;
      }
      this.tableHeight = height - 120 - formH; //表单的高度会变化
    },
    onSubmit() {
      this.getWorkshopInfo();
    },
    onReset() {
      this.queryParams = {
        factoryName: '',
        workshopName: ''
      };
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store.dispatch('workshop/getFactoryByCustomer', this.queryParams).then((result) => {
        this.factoryOptions = result.data;
        if (this.factoryOptions.length > 0) {
          this.queryParams.factoryId = result.data[0].id;
          this.getWorkshopByFactory();
        }
      });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store.dispatch('scene/getWorkshopByFactory', { factoryId: this.queryParams.factoryId }).then((result) => {
        if (result && result.data && result.data.length > 0) {
          this.workshopOptions = result.data;
          this.queryParams.workshopId = result.data[0].id;
        } else {
          this.workshopOptions = [];
          this.queryParams.workshopId = null;
        }
        this.getWorkshopInfo();
      });
    }
  },
  mounted() {
    if (!this.isMounted) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
      this.initGraph();
      this.getFactoryByCustomer();
      this.isMounted = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.title-box {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  padding: 27px 0 15px;
  line-height: 16px;
}
::v-deep .scene_tabs .el-tabs__header {
  margin-bottom: 0;
}
::v-deep .scene_tabs.el-tabs--card > .el-tabs__header .el-tabs__item {
  background: #fff;
  border-radius: 16px 16px 0 0;
  margin-right: 35px;
}
::v-deep .scene_tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: rgba(0, 0, 0, 0);
  background: #3083fb;
  color: #ffefef;
}
::v-deep .scene_tabs .el-tabs__content {
  height: calc(100% - 40px);
  .el-tab-pane {
    height: 100%;
    background: #fff;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
  }
}
</style>
